import { memo } from "react";
import * as Styled from "./style";
import { Carousel } from "~/components/blocks/common/carousel";

export type CarouselSkeletonItem = {
  isFirstItem: boolean;
  isLastItem: boolean;
  alt: string;
  borderRadius: string;
  aspectRatio: string;
  src: string;
};

type Props = {
  items: CarouselSkeletonItem[];
  displayItemCount: number;
};

export const CarouselListSkeleton = memo(({ items, displayItemCount }: Props) => (
  <Styled.DivCarouselWrapper>
    <Styled.CarouselHeadingSkeleton type="square" animType="fade" width={220} borderRadius={8} />
    <Carousel
      displayItemCount={displayItemCount}
      uniqueId="0"
      items={items}
      skeletonSetting={{
        isShowSkeleton: true,
        aspectRatio: "7/5",
      }}
    />
  </Styled.DivCarouselWrapper>
));
CarouselListSkeleton.displayName = "CarouselListSkeleton";
